export const AUTONOMOUS_LABEL = 'Autonomous';

export const BETA_LABEL = 'Beta';

export const BETA_TOOLTIP =
  'Beta. Autonomous Checkout is a research preview and is still learning, so results improve over time.';

export const AUTONOMOUS_DISCOUNT_PITCH =
  'Autonomous Checkout picks the discount for each shopper in real time, then learns which of the values below converts best.';
